import api from '~/services/api';
import { store } from '~/store';
/*
 * Serviço resposavel por interação com api
 */
export class LinhasDeCuidadoFormularioApi {
  token = null;
  constructor() {
    const { token, roles, cnes } = store.getState().auth;
    this.token = token;
  }
  obterFormularioEletronico = async careLine => {
    let response = await api.get(
      `indicadores-linhas-de-cuidado/${careLine}/formulario-eletronico`,
      {
        headers: {
          Authorization: this.token,
        },
      }
    );
    if (
      String(response?.status).substr(0, 2) === '20' &&
      response.data.length > 0
    ) {
      return response.data;
    }

    return [];
  };

  obterRegistroUpdate = async (careLine, id) => {
    let response = await api.get(
      // `/indicadores-linhas-de-cuidado/obter-formulario-eletronico/${careLine}/${id}`,
      `indicadores-linhas-de-cuidado/${careLine}/formulario-eletronico/${id}`,
      {
        headers: {
          Authorization: this.token,
        },
      }
    );

    if (
      String(response?.status).substr(0, 2) === '20' &&
      typeof response.data != 'undefined'
    ) {
      return response.data;
    }

    return [];
  };

  save = async (careLine, period, data) => {
    // data.periodo = period;

    let response = await api
      .post(
        // `/indicadores-linhas-de-cuidado/salvar-formulario-eletronico/${careLine}?periodo=${period}`,
        `indicadores-linhas-de-cuidado/${careLine}/formulario-eletronico?periodo=${period}`,
        data,
        {
          headers: {
            Authorization: this.token,
          },
        }
      )
      .catch(e => {
        return e.response;
      });

    if (String(response?.status).substr(0, 2) === '20') {
      return { isValid: true };
    } else {
      if (response?.data?.fields?.length > 0) {
        return { isValid: false, errors: response.data.fields };
      }
    }
    return { isValid: false };
  };

  update = async (careLine, id, data) => {
    let response = await api
      .put(
        // `/indicadores-linhas-de-cuidado/salvar-formulario-eletronico/${careLine}/${id}`,
        `indicadores-linhas-de-cuidado/${careLine}/formulario-eletronico/${id}`,
        data,
        {
          headers: {
            Authorization: this.token,
          },
        }
      )
      .catch(e => {
        return e.response;
      });

    if (String(response?.status).substr(0, 2) === '20') {
      return { isValid: true };
    } else {
      if (response?.data?.fields?.length > 0) {
        return { isValid: false, errors: response.data.fields };
      }
    }
    return { isValid: false };
  };
}
